<template>
  <div class="NewsArticlesContentBlock">
    <div class="grid">
      <div class="col-6-12 push-1-12 sm-col-1-1 sm-push-0">
        <p
          v-if="content.subtitle"
          class="subtitle mb-xlg"
        >
          {{ content.subtitle }}
        </p>
        <UIHeadingType
          class="mb-xxxlg"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
      </div>

      <div class="col-1-1 no-p">
        <BaseArticleOverview
          :config="articleConfig"
          :sortings="sortings"
          :page-id="menuId"
          :instance-key="contentblockIdx"
          class="clearfix"
        >
          <template #articles="{ articles }">
            <div
              v-for="(article, index) in articles"
              :key="`${article._id}-${index}`"
              class="col-10-12 push-1-12 sm-col-1-1 sm-push-0 no-p article-row"
            >
              <div class="col-4-10 sm-col-1-1">
                <h4 class="pr-lg sm-pr-0 sm-mb-lg">
                  {{ article.content.title }}
                </h4>
              </div>
              <div class="col-6-10 sm-col-1-1">
                <p
                  v-if="article.content.subtitle"
                  class="article-text"
                >
                  {{ article.content.subtitle }}
                </p>
                <UIContentblockButton
                  v-if="article._url"
                  name="Lees meer"
                  :link="article._url"
                  target="_self"
                  class="btn btn-tertiary no-underline covering-link"
                />
              </div>
            </div>
          </template>
        </BaseArticleOverview>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { NewsArticlesContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  const props = defineProps<{
    content: NewsArticlesContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()

  const defaultPageSize = 3
  const defaultMenuId = 2152

  const menuId = computed(() => parseInt(props.content.fillWithId) || defaultMenuId)

  const presetArticles = computed(() => {
    const list = []
    if (props.content.articleList?.length) {
      list.push(...props.content.articleList)
    }
    return list
  })

  const articleConfig = computed(() => ({
    articles: {
      presetArticles: presetArticles.value,
      fillWithPageId: presetArticles.value.length === 0,
    },
    pagination: {
      enabled: false,
      show: false,
      articlesPerPage: Number(props.content.maxArticles) || defaultPageSize,
    },
    search: {
      enabled: false,
      show: false,
    },
    filters: {
      enabled: false,
      show: false,
    },
  }))

  const sortings = [
    {
      id: 1279,
      desc: true,
    },
  ]
</script>

<style lang="scss" scoped>
  .article-row {
    position: relative;
    border-top: 1px solid rgba($black, 0.1);
    padding-top: 4rem;
    padding-bottom: 4rem;
    transition: opacity 0.2s var(--ease-fast-in-slow-out);
  }

  :deep(.BaseArticleOverview) {
    &:hover .article-row {
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }

  .article-text {
    margin-bottom: var(--margin-md);
    overflow: hidden;
    @include line-clamp(2);
  }

  @include media(sm) {
    .article-text {
      @include line-clamp(4);
    }
  }
</style>
